import React, { useEffect } from 'react';
import { useRecoilState, useSetRecoilState, useResetRecoilState } from 'recoil';
import { RoutesStatesAtom, RoutesStates } from '../../atoms/routesStates';

import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { RedocStandalone, Redoc } from 'redoc';
import { useTheme } from '../../context/ThemeContext';

export const OpenApiDoc: React.FC = () => {

  const lightTheme = {
    colors: {
      primary: { main: '#1a73e8' },
      background: { main: '#ffffff', sidebar: '#f7f7f7' },
      text: { primary: '#000000' },
    },
  };
  
  const darkTheme = {
    colors: {
      primary: { main: '#90caf9' },
      success: { main: '#66bb6a' },
      warning: { main: '#ffa726' },
      error: { main: '#ef5350' },
  
      text: {
        primary: '#ffffff',
        secondary: '#bbbbbb',
      },
  
      background: {
        main: '#000000',    // Page background
        sidebar: '#000000', // Sidebar
        codeBlock: '#000000',
      },
  
      
    },
  
   
  
    sidebar: {
      backgroundColor: '#1f1f1f',
      textColor: '#ffffff',
      arrow: {
        color: '#bbbbbb',
      },
    },
  
    rightPanel: {
      backgroundColor: '#181818',
      textColor: '#ffffff',
    },
  
    
  };
  
  
  const { isDarkMode } = useTheme();


  return (
    <div style={{ backgroundColor: isDarkMode ? '#121212' : '#ffffff' }}>
      <script src="https://cdn.redoc.ly/redoc/latest/bundles/redoc.standalone.js"></script>

      {/* <SwaggerUI url="./openapi/openapi.yml" /> */}
      <RedocStandalone
         specUrl="./openapi/openapi.yml"
         options={{
           nativeScrollbars: true,
           theme: isDarkMode ? darkTheme : lightTheme,
         }}
       />
    </div>
  );
};